<template>
    <b-overlay :show="showoverlayapprove" rounded="sm">
       
        <table class="table table-hover">
            <tbody>
                <tr class="table-head">
                
                    <td style="text-align: left;">Activity at</td>
                    <td style="text-align: left;">Status</td>
                    <td style="text-align: left;">Level</td>                
                    <td style="text-align: left;">Designation</td>
                    <td style="text-align: left;">Name</td>                                
                    <td style="text-align: left;">Comment</td>
                
                </tr>
            <template v-if="paginatedData.length">
                <tr class="table-row" v-for="(log,index) in paginatedData" :key="log.id">
                    <td>{{  formatMe(log.updated_at)  }} | {{ formatTime(log.updated_at) }}   </td>
                    <td>{{log.status}}</td>
                    <td>{{log.level}}</td>                    
                    <td>{{log.designation}}</td>
                    <td>{{log.comment_by_name}}</td>                    
                    <td>{{log.comment}}</td>                
                </tr>
                
                <tr v-if="paginatedData.length > 0"><td :colspan=6 class="no-border bg-white"> <!-- Mustafijur: gf_unified: 04-08-2026 -->
                        <div class="row p-2 float-right" >
                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                </div></td></tr>
                
                
                </template>
                <template v-else>
                <tr>
                    <td colspan="7" class="border text-center bg-white">{{log_not_available}}</td> <!-- Mustafijur: gf_unified: 04-08-2026 -->
                </tr>
                </template>
                
            </tbody>
        </table>
    </b-overlay>
</template>
<style scoped>
button.disabled{cursor: default;}
</style>

<script>

import moment from 'moment';
    export default{
        props: ['pageurl','application_id','module','company_id'],        
        data(){
            return {
                company_name: '',
                pgurl:this.pageurl,
                showoverlayapprove: false,
                approval_data: [],  
                logs : [],             
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                search : '',
                search_by_id:{payrun_id:'', payrun_id_form:''},
                per_page:10,  
                sortOrders: {},         
            }
        },
        methods:{   
            getlogs: function()
			  {
			    
                     this.showoverlay = true;
                     this.log_not_available = 'Loading please wait....';
                     
                     axios.get(this.pageurl+'/approver/approval-history', {
                            params: {
                                application_id:this.application_id,
                                module:this.module,
                                company_id:this.company_id,
                            }
					  }).then(function(response){
					  this.logs = response.data;
					  this.pagination.from = response.data.from;
					  this.pagination.to = response.data.to;
					  this.pagination.total = response.data.total;
                      
                      this.showoverlay = false;
                      if(this.logs && this.logs.length>0)
                      this.log_not_available = '';
                      else
                      this.log_not_available = 'No history to show.';
					  
					  if(this.pagination.to==this.pagination.total)
					  {
						  
						  this.pagination.nextbuttonstatus = 'disabled';
						  
					  }
					  else
					  {
						   this.pagination.nextbuttonstatus = '';
					  }
					  
					  if(this.pagination.from==1)
					  {
					  this.pagination.prebuttonstatus = 'disabled';
					  }
					  else
					  {
						 this.pagination.prebuttonstatus = ''; 
					  }
  
  
  
					  if(this.pagination.currentPage < response.data.last_page)
						  this.pagination.nextPage = this.pagination.currentPage + 1;
  
					  if(this.pagination.currentPage == 1)
						  this.pagination.prevPage = 1;
					  else 
						  this.pagination.prevPage = this.pagination.currentPage - 1;
				  }.bind(this));
			  },         
          
           getApprovalHistory: function(){
            let currentObj = this;
            axios.get(this.pageurl+'/approval-history', {
                    params: {
                        ref_id:this.ref_id,
                        module:this.module,
                        company_id:this.company_id,
                    }
                    })
              .then(function (response) {
                 this.showoverlay = false;
                 if(response.data.data){
                    this.incompleted_total = response.data.data.length;
                    this.wizard_data = response.data.data;
                 }
              }.bind(this)).catch(function (error){currentObj.serverError(error);});
            }, 
            formatMe(d)
            {
               return moment(d).format('MMMM D, Y');
            },
            
            formatTime (d)
            {
                return moment(d).format('hh:mm:ss A');
            },
        },
        created: function(){
            this.getlogs();
        },
        computed: 
        {
        filteredData() 
        {
            let filtered_list = this.logs;
            if (this.search) 
            {
                filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
            
                if(filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";                
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) 
            {
                filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                        a = String(a[sortKey]).toLowerCase();
                        b = String(b[sortKey]).toLowerCase();
                        if (this.columns[index].type && this.columns[index].type === 'date') 
                        {
                            return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                        } 
                        else if (this.columns[index].type && this.columns[index].type === 'number') 
                        {
                            return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                        } 
                        else 
                        {
                            return (a === b ? 0 : a > b ? 1 : -1) * order;
                        }
                    }
                );
            }
            
            return filtered_list;
        },
        paginatedData() 
        {     
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },


        }
    }
</script>
